@use '@/scss/underscore' as _;

.title {
  @include _.section-head-2;
  color: var(--color-neutral-variant-70);
  padding: _.unit(2) _.unit(6);
}
